















import { Vue, Component, Prop, Emit } from 'vue-property-decorator'

@Component
export default class HIVETextField extends Vue {
  @Prop(String) public label: string
  @Prop(String) public value: string
  @Prop(Boolean) public required: boolean
  @Prop(Number) public counter: number
  @Prop(Array) public rules: Array<object>

  private get getLabel() {
    return this.label
  }

  private get getValue() {
    return this.value
  }

  private get getRequired() {
    return this.required
  }

  private get getCounter() {
    return this.counter
  }

  private get getRules() {
    return this.rules
  }
}
